import { render, staticRenderFns } from "./FrzPackingWorkStation.vue?vue&type=template&id=074c63f0"
import script from "./FrzPackingWorkStation.vue?vue&type=script&lang=js"
export * from "./FrzPackingWorkStation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports